
import React from 'react'
import Nav from '../Nav/Nav'
import Hero from './Hero'
import Stats from './Stats'
import Why from './Why'
import Newsletter from './Newsletter'
import JoinAsATeacher from './JoinAsATeacher'
import CallRequest from './CallRequest'
import Footer from '../Footer/Footer'
import Testimonial from '../Testimonial/Testimonial'
import LatestNews from './LatestNews'
import Checkout from './Checkout'
import MobileTestimonial from '../Testimonial/MobileTestimonial'

const Home = () => {
  return (
    <>
    
    <Nav />
    <Hero />
    <Stats />
    <Why />
    <Checkout />
    <Testimonial />
 
    <JoinAsATeacher />
    <CallRequest />
    <LatestNews />
    <Newsletter />
    <Footer />
    </>
  )
}

export default Home